import {util} from '../utils'
import {CancelToken} from 'axios'

let history = { // ajax历史记录
  'option': [ // 等待队列
    {
      resolve: null,
      reject: null
    }
  ]
}
let timer = {
  'url': {
    id: 0,
    cancel: null,
    reject: () => {}
  }
} // 计时器管理

export default function (ajax) {
  return function (option = {
    url: '',
    responseOnce: false, // 如果只响应一次，则后续请求直接reject即可
    /**
     * 指定unique后，代表同一时间内，该url的请求只能存在一个（取消前置请求）
     * 当值为字符串时，url+unique值共同组成timer的key，以此来作为相同请求的判定
     */
    unique: false,
    delay: 0 // 延时请求(unique的配合参数)
  }) {
    return new Promise((resolve, reject) => {
      // 如果请求返回之前，同样的请求传递过来，则在返回中将后续请求一并resolve，而不再重复发送请求到服务器
      let key = JSON.stringify(option)
      const timerKey = option.url + '_' + (util.isString(option.unique) ? option.unique : '')
      if (option.unique && timer[timerKey]) { // 如果查询已存在，则取消前一个请求
        clearTimeout(timer[timerKey].id)
        if (timer[timerKey].cancel) {
          timer[timerKey].cancel()
        } else {
          let cancel = new Error('cancel: before request')
          cancel.__CANCEL__ = true // 兼容axios的判断
          timer[timerKey].reject(cancel)
        }
        delete timer[timerKey]
        if (history[key]) delete history[key]
      }
      if (!history[key]) {
        history[key] = [{
          resolve,
          reject
        }]

        let request = function () {
          if (/{{\S*}}/.test(option.url)) {
            const params = option.url.match(/{{\S*?}}/g)
            params.forEach(param => {
              const key = param.replace(/[{|}]/g, '')
              option.url = option.url.replace(param, option.params[key])
              delete option.params[key]
            })
          }
          if (option.useTransform) {
            option.transformRequest = function (params) {
              var arr = []
              for (let key in params) {
                let value = params[key]
                if (util.isObject(value) || util.isArray(value)) {
                  value = JSON.stringify(value)
                }
                arr.push(`${key}=${encodeURIComponent(value)}`)
              }
              return arr.join('&')
            }
          }
          ajax(option).then(res => {
            if (history[key] && history[key].length) history[key].forEach(item => {
              item.resolve(res)
            })
          }).catch(err => {
            if (history[key] && history[key].length) history[key].forEach(item => {
              item.reject(err)
            })
          }).finally(() => {
            delete timer[timerKey]
            delete history[key]
          })
        }

        if (option.unique) {
          timer[timerKey] = {
            id: 0,
            option,
            cancel: null,
            reject
          }
          timer[timerKey].id = setTimeout(() => {
            option.cancelToken = new CancelToken(c => {
              if (timer[timerKey]) {
                timer[timerKey].cancel = c
              }
            })
            request()
          }, option.delay || 0)
        } else {
          request()
        }
      } else if (option.responseOnce) { // 如果已经有相同请求在进行，且responseOnce，则以cancel形式取消该请求
        let cancel = new Error('cancel: before request')
        cancel.__CANCEL__ = true // 兼容axios的判断
        reject(cancel)
      } else { // 有相同请求，但是请求需要以正常结果返回，则加入请求队列，第一个请求响应后一并响应
        history[key].push({
          resolve,
          reject
        })
      }
    })
  }
}
